import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomValidator } from 'src/app/shared/customvalidator/customvalidator';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { LANDING_ROUTE } from 'src/app/app-data';
import { HttpInterceptorService } from 'src/app/shared/services/http-interceptor.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm!: FormGroup;
  submitted = false;
  errorMessages: any = {};
  backendErrorMsg: any = '';
  isStatus400: boolean = false;
  isStatus423: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private apiService: ApiService,
    private router: Router,
    private toastrService: ToastrService,
    private localStorageService: LocalStorageService,
    private authService: AuthService,
    private httpInterceptorService: HttpInterceptorService
  ) {
  }

  ngOnInit() {
    this.errorMessages = CustomValidator.LoginErrorMessages;
    this.initializeFormBuilder();
  }
  initializeFormBuilder() {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(32), CustomValidator.alphanumericNoSpaces]],
      password: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(20), CustomValidator.alphanumericWithSpecialChar]],
    });
  }
  get loginFormGroupControls() {
    return this.loginForm?.controls;
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }
    const apiUrlPath: string = environment.routes.LOGIN_API;
    const payload: any = {}
    return this.apiService.post(apiUrlPath, this.loginForm.value).subscribe(response => {

      if (response?.status == 200) {
        //success response
        // Session is now carried via an HttpOnly cookie set by the backend — do not
        // persist the JWT to localStorage.
        this.localStorageService.setItem('id', response?.data[0].id);
        this.localStorageService.setItem('username', response?.data[0].username);
        this.localStorageService.setItem('user_role', response?.data[0].role);
        this.localStorageService.setItem('temp_user', response?.data[0].temp_user);
        this.localStorageService.setItem('status', response?.data[0].status);
        this.localStorageService.setItem('reset_at', response?.data[0].reset_at);

        this.localStorageService.setUser({ ...response?.data[0] });
        this.authService.setLoginStatus(true);
        // this.httpInterceptorService.resetSessionExpiry();

        let isTempUser = response?.data[0]?.temp_user;
        isTempUser ? (this.router.navigate(['/reset-password', response?.token])) : (this.router.navigate([LANDING_ROUTE[response?.data[0].role as keyof typeof LANDING_ROUTE]]));
      } else {
        this.backendErrorMsg = response?.message || response?.error.message;
      }
    }, error => {
    });
  }

}
